import React from 'react';
import { StyleSheet } from 'react-native';
import { View } from './View';
export const Row = ({ children, style = {}, }) => (React.createElement(View, { style: StyleSheet.flatten([
        {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: 'transparent',
        },
        style,
    ]) }, children));
//# sourceMappingURL=Row.js.map